// Accès à l'onboarding « Par quoi commencer » (déploiement progressif).
//
// FAIL-CLOSED : par défaut PERSONNE n'y a accès. Seuls les e-mails de la liste blanche
// ci-dessous voient l'entrée « Démarrer » et peuvent ouvrir l'écran d'onboarding. Un
// utilisateur sans e-mail lisible, ou hors liste, est traité comme non autorisé.
//
// Ce garde-fou protège les 1 840 clients : la fonctionnalité est déployée mais reste
// invisible et inaccessible pour tout le monde sauf la liste blanche, le temps de la
// valider en conditions réelles. Élargir l'audience = ajouter des e-mails ici + redéployer.
//
// Rollout progressif : Charly (1er passage prod) + Axel (ajouté 17/07). Invisible pour
// tous les autres, y compris le reste de l'équipe et les 1 840 clients. Élargir ensuite
// en ajoutant des e-mails ici. E-mails en minuscules (comparaison sur l'e-mail Keycloak
// minuscule). Même modèle que overviewAccess.js / edlAccess.js.
const ONBOARDING_ALLOWLIST = ['charly.leggeri@limeare.com', 'axel@horiz.io']

// E-mail de connexion (Keycloak), en minuscules. '' si non lisible -> non autorisé.
function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').trim().toLowerCase()
}

export function isOnboardingEnabled() {
  const email = getCurrentEmail()

  return !!email && ONBOARDING_ALLOWLIST.includes(email)
}
